import PlansManagementV2 from './PlansManagementV2';
export default PlansManagementV2;
